export interface AuthUserForDisplay {
  firstName?: string | null
  lastName?: string | null
  username?: string | null
  primaryEmailAddress?: { emailAddress: string } | null
  emailAddresses?: Array<{ emailAddress: string }>
}

export const getUserDisplayName = (authUser: AuthUserForDisplay | null | undefined): string | null => {
  if (authUser) {
    const firstName = authUser.firstName || ''
    const lastName = authUser.lastName || ''
    const fullName = `${firstName} ${lastName}`.trim()
    if (fullName) return fullName

    if (authUser.username) return authUser.username
    if (authUser.primaryEmailAddress) {
      return authUser.primaryEmailAddress.emailAddress.split('@')[0]
    }
    if (authUser.emailAddresses?.length) {
      return authUser.emailAddresses[0].emailAddress.split('@')[0]
    }
  }
  return null
}


